import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { Theme } from 'scripts/react-components/themes/Theme'

const chatButtonWrapper = () => css`
  label: wrapper;
  position: relative;

  & > [id^='tippy-'] {
    animation: opac 2s;
    animation-timing-function: ease-in-out;
    transition: opacity 2s;
    opacity: 1;
  }
  & > [id^='tippy-'].to-hide {
    opacity: 0;
  }

  @keyframes opac {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

const chatButton = ({ theme }: Theme) => css`
  label: button;

  z-index: 50;
  border-radius: ${theme.borderRadius.circle};
  display: flex;
  width: 64px;
  height: 64px;
  background-color: ${theme.colors.p600};
  justify-content: center;
  align-items: center;
  padding: ${theme.spacings.kilo};
  margin-left: ${theme.spacings.giga};
  margin-bottom: ${theme.spacings.tera};

  &:hover {
    background-color: ${theme.colors.p800};
  }

  svg {
    fill: ${theme.colors.white};
  }
`
export const ChatButtonWrapper = styled('div')(chatButtonWrapper)
export const ChatButton = styled('div')(chatButton)
